
// notifications.service.ts

import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})

export class NotificationsService {
  constructor(private snackBar: MatSnackBar) {}

  // Method to show a notification
  showNotification(
    message: string,
    type: 'success' | 'error' | 'warning' | 'info' = 'info',
    duration: number = 3000, // Duración por defecto
    verticalPosition: MatSnackBarVerticalPosition = 'bottom',
    horizontalPosition: MatSnackBarHorizontalPosition = 'right'
  ): void {
    const panelClass = this.getPanelClass(type);
    this.snackBar.open(message, '', {
      duration,
      verticalPosition,
      horizontalPosition,
      panelClass
    });
  }

  // Mapping types to panel classes (CSS)
  private getPanelClass(type: string): string {
    switch (type) {
      case 'success':
        return 'snackbar-success';
      case 'error':
        return 'snackbar-danger';
      case 'warning':
        return 'snackbar-warning';
      case 'info':
      default:
        return 'snackbar-info';
    }
  }

  // Methods to show different types of notifications

  success(message: string, duration?: number): void {
    this.showNotification(message, 'success', duration);
  }

  error(message: string, duration?: number): void {
    this.showNotification(message, 'error', duration);
  }

  warning(message: string, duration?: number): void {
    this.showNotification(message, 'warning', duration);
  }

  info(message: string, duration?: number): void {
    this.showNotification(message, 'info', duration);
  }
}

